export const SET_PLAYLISTS = "SET_PLAYLISTS";
export const SET_SINGLE_PLAYLIST = "SET_SINGLE_PLAYLIST";